<template>
  <b-modal
    id="file-input-modal"
    ref="fileInputModal"
    class="static-modal"
    :modal-class="{preloading: false, 'hide-send': false, 'assistant-forms': true, hide: !initialized }"
    title-class="flex flex-align-center"
    :body-class="{}"
    size="xl"
    :lazy="true"
    no-close-on-backdrop
    hide-header-close
    centered
    scrollable
    :hide-backdrop="!initialized"
    @hidden="clear">
    <!-- Modal HEADER -->
    <template slot="modal-header" >
      <div>
        <h3>{{ data.title }}</h3>
        <div class="subtitle flex flex-align-center">
          <SBIcon
            class="mr-1"
            :icon="SBIconList.INFO"
            :color="SBColors.greyLight"
            :size="10" />
          <p v-html="data.subtitle" />
        </div>
      </div>
    </template>

    <!-- MODAL BODY -->
    <!-- <pre>{{ data }}</pre> -->
    <!-- <pre>{{ value }}</pre> -->

    <JsonSchema
      ref="jsonSchema"
      v-model="formValue"
      :schema="schema"
      :components="componentsConfig"
      :ui-schema="uiSchema"
      :wrapper="wrapperComponentConfig"
      @init-default="initDefault"
      @input="() => {}" />
    <!-- MODAL BODY end-->

    <template slot="modal-footer">
      <b-button
        :class="{loading: false}"
        :disabled="false"
        @click="hide">
        <span>Cancel</span>
        <div
          class="loader-15 black"
        ><div class="loading-circle"/></div>
      </b-button>
      <b-button
        variant="primary"
        :class="{loading: false}"
        :disabled="!formValid"
        @click="emitData">
        <span>Save</span>
        <div
          class="loader-15 black"
        ><div class="loading-circle"/></div>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import JsonSchema from '@roma219/vue-jsonschema-form';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import ToasterMixin from '@/mixins/Toaster';
// import ComponentsConfig from '../ComponentsConfig';  // ---------
import FormSchemaMixin from '../FormSchema.mixin';

export default {
  name: 'FormSchemaModal',
  components: {
    SBIcon,
    JsonSchema,
  },
  mixins: [
    ToasterMixin,
    FormSchemaMixin,
  ],
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      initialized: false,
      edited: false,
      formValue: {},
      formValid: false,
      duplicateFiles: [],
      errorFiles: [],
      inputId: '',
      dropActive: false,
      extensions: ['pdf', 'jpg', 'jpeg', 'png'],
      unsupportedFileTypeMessage: 'Unsupported file type.',
      maxFileSize: 16 * 1000000, // 16MB                     // TODO implement
      fileTooBigMessage: 'File is too big.',
      searchQuery: '',
      searchQueryAfterDebounce: '',
      blockNewFiles: false,
      SBColors,
      SBIconList,
      // ComponentsConfig,  // ---------
      // schema: {},
      schemaBP: {},
    };
  },
  computed: {
    ...mapGetters({}),
  },
  watch: {
    formValue: {
      handler() {
        // console.log('CHANGE');
        this.edited = true;
        this.formValid = this.checkFormValid(this.formValue);
      },
      deep: true,
    },
  },
  beforeMount() {
    // this.inputId = `fileField-${randomString()}`;
  },
  mounted() {
    // console.log(1111);
    // console.log(this.data);
    // this.schemaBP = this.data.schema;
    // console.log(222);

    // Initiates the population of the modal form but keeps it invisible before the data is ready after which the modal is closed and set to be visible when user requests it.
    this.show(this.value);
    setTimeout(() => {
      this.emitData();
      this.hide();
    }, 10);
  },
  methods: {
    ...mapActions({}),
    show(data) {
      this.schemaBP = { ...this.data.schema };
      if (data && Array.isArray(data)) { // currently operates files only
        this.files = data && data.value ? [...data.value].map(f => new File([f], f.name)) : [];
      } else if (data && data) {
        // this.formValue = data.value;
        // console.log('DATA');
        // console.log(data);
        Object.keys(data).forEach((key) => {
          // if (key === 'radio') {
          //   return;
          // }
          const targetField = this.findFieldInSchema(this.schemaBP, key);
          // console.log('TARGET FIELD');
          // console.log(targetField);
          // if (targetField) {
          //   targetField.value = data[key].data.value;
          // }
          let targetValue;
          switch (targetField.type) {
            case 'message-buttons':
              if (data[key].data && data[key].data.value.filter(v => v).length) {
                targetValue = data[key].data.value.filter(v => v).map(button => ({ title: button }));
              }
              if (targetValue) {
                targetField.value = targetValue;
              }
              break;
            default:
              targetField.value = data[key] && data[key].data ? data[key].data.value : '';
              break;
          }
        });
      }

      this.$refs.fileInputModal.show();
      setTimeout(() => {
        this.focusFirstInput();
      }, 0);
    },
    clear() {
      this.$set(this, 'formValue', {});
      this.$emit('closed');
      if (!this.initialized) {
        this.$emit('initialized');
        this.initialized = true;
      }
    },
    checkFormValid(form) {
      // console.log(form);
      return !Object.keys(form).some((component) => {
        // First check if it has 'Value' key. If it doesn't have it then this is a subform and it needs to be passed to the checkData function recursively.
        if (form[component].valid === undefined) {
          if (!this.checkFormValid(form[component])) {
            return true;
          }
          return false;
        }
        if (form[component] && form[component].valid === false) {
          return true;
        }
        return false;
      });
    },
    hide() {
      this.files = [];
      this.errorFiles = [];
      this.duplicateFiles = [];
      this.$refs.fileInputModal.hide();
      this.edited = false;
    },
    emitData() {
      this.$emit('input', this.formValue);
      this.hide();
    },
    /** Checks if the target is the child of specified parent. */
    findParentById(element, id) {
      if (element.id === id) {
        return element;
      }
      if (element.parentElement) {
        return this.findParentById(element.parentElement, id);
      }
      return null;
    },
    focusFirstInput() {
      const input = document.getElementById('file-input-modal').querySelector('input.empty, .ql-editor.ql-blank');
      if (input) input.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  margin-top: 3px !important;
  font-size: 12px !important;
  font-weight: normal !important;
  text-align: left !important;
  color: $blackUltralight !important;

  ::v-deep a {
    color: $blackUltralight !important;
    text-decoration: underline !important;
  }
}

::v-deep .modal {
  .modal-content {
    border-radius: 10px !important;
  }

  .modal-header {
    padding: 18px 15px !important;
    h3 {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.2;
    }
    p {
      font-size: 12px;
      font-weight: 400;
      color: $blackUltralight;
    }
  }

  .modal-body {
    // padding: 18px 15px !important;
    padding: 15px !important;
    // min-height: 212px;

    // &.no-bottom-padding {
    //   padding-bottom: 0 !important;
    // }

    .add-button {
      position: sticky;
      bottom: 0px;
      background: $greyUltralight;
      // margin: 0 -15px;
      padding: 18px 15px;

      * {
        font-size: 14px;
        font-weight: 500;
        color: $blackPrimary;
      }

      > div {
        min-height: 34px;
        padding: 9px 12px;
        border-radius: 10px;
        background: $greyBorderSecondary;
        // cursor: pointer;
        &:hover {
          background-color: #DDE6E9;
        }
      }
    }
  }

  .modal-footer {
    button {
      border-radius: 10px;

      &.btn-secondary {
        border: solid 1px $greyBorder;
      }
    }
  }
}
</style>
